// extracted by mini-css-extract-plugin
module.exports = {"solutions":"styles_solutions__19JU9","tab-bar":"styles_tab-bar__1rQ7z","active":"styles_active__1-xQg","tab-content-active":"styles_tab-content-active__2_zDw"};